import React, {useEffect, useState} from 'react';
import { Link as RouterLink, useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Box } from '@mui/material';
import { Update } from '../sections/@dashboard/managePolicy';
import { useGetOnePolicyQuery } from '../services/dvagent';
import { Toaster } from '../sections/@dashboard/attributes';
import { getToken, getAdmin } from '../services/LocalStorageService';
import { PropertyViewCard } from '../components/skeleton';
import { Unauthorized } from '../sections/@dashboard/manageUser';

export default function PolicyUpdate() {

  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [policy, setPolicy] = useState({});
  const { data, isSuccess, error } = useGetOnePolicyQuery({ "id": location.state, "token": getToken(), "location":location });
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    setLoading(false);
    if (error) {
      if (error.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
      setTimeout(() => {
        setLoading(true);
      }, 2000);
    }
    if (data && isSuccess) {
      setPolicy(data);
      setLoading(true);
    } else {
      setTimeout(() => {
        setLoading(true);
      }, 2000);
    }
  }, [data, isSuccess, error]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Box to="/cloud/users" component={RouterLink} state={{ dropdownState: 'Policies' }}>
              <img width={40} src="../../assets/back-button.gif" alt="verified" style={{ marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
            </Box>
            <Typography
              gutterBottom
              variant=""
              component="div"
              sx={{
                color: '#A8A196',
                textAlign: 'left',
                marginLeft: 2,
                fontSize: '1.2rem',
                fontWeight: 'bold',
              }}
            >
              I AM
              <Typography variant="" component="div" sx={{ fontSize: 12, color: '#4D4D4D' }}>
                POLICY INFORMATION
              </Typography>
            </Typography>
          </div>
        </Grid>
        {loading ? (
          <Grid container spacing={2} mt={1}>
            {getAdmin() === 'false' ? <Unauthorized/> :<Update policy={policy}/>}
          </Grid>
        ):(
          <Grid container spacing={2}>
            <PropertyViewCard/> 
          </Grid>
        )}
      </Container>
    </>
  );
}